export default "__VITE_ASSET__aTPRkZoJ__"